import React from 'react';
import PrivateRoute from 'PrivateRoutes';
const REPORT = React.lazy(()=> import(/* webpackChunkName: "BreakReports" */'./components'));

const routes = () => (
  <PrivateRoute exact path="/reporting/break-summary" component={REPORT} />
);

export default routes;



// WEBPACK FOOTER //
// src/modules/screens/reporting/BreakReport/routes.js